import Vue from "vue"
import VueRouter from "vue-router"
import {authRoutes} from "@/router/auth"
import {homeRoutes} from "@/router/home"
import {demoRoutes} from "@/router/demo"
import {getTitleByRoute} from "@/utils/routingHelper"
import {canAccessRoute} from "@/utils/permissionHelper"

const { push } = VueRouter.prototype
const { isNavigationFailure, NavigationFailureType } = VueRouter

VueRouter.prototype.push = function (location) {
    return push.call(this, location).catch(error => {
        if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
            throw Error(error)
        }
    })
}

Vue.use(VueRouter)

let routes = [].concat(authRoutes, homeRoutes)
if (process.env.NODE_ENV === 'development') {
    // TODO: Add if needed
    routes = routes.concat(demoRoutes)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: routes,
})

router.beforeEach((to, from, next) => {
    const loggedIn = Vue.prototype.$stateManagement.state.auth.isLoggedIn
    const authRequired = !!to.meta.auth

    document.title = getTitleByRoute(to)

    // Check authentication first
    if (authRequired && !loggedIn) {
        next({ name: 'login', query: { from: to.name }, params: { to } })
        return
    }

    // If authenticated and auth required, check permissions
    if (authRequired && loggedIn) {
        const permissions = Vue.prototype.$stateManagement.getters["auth/permissions"] || []
        const hasAccess = canAccessRoute(permissions, to.name, to.path)
        
        if (!hasAccess) {
            // Redirect to home with permission error message (using query to avoid URL pollution)
            next({ 
                name: 'home',
                query: { 
                    permissionError: 'true'
                },
                replace: true
            })
            return
        }
    }

    next()
})

export default router
